import {
    getAxios,
    formDataToRequestParams,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberMessageList(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/messages/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}

export function actionFilterMemberMessage(data = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/messages/action/',
        method: 'post',
        data: formDataToRequestParams(addAuthTokenData(data))
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberMessageList.js